export default __webpack_public_path__ + "static/media/my colony.0b4852cc.svg";